import { BLOCK_KEYS, type BlockDraft, type IntakeArtist, type IntakeDraft } from "../types";

const clean = (s: string) => (s.trim() ? s.trim() : undefined);
const block = (b: BlockDraft) => {
  const text = clean(b.text);
  return text ? { text, refs: b.refs } : { refs: b.refs };
};

export function buildPayload(d: IntakeDraft, artist: IntakeArtist, locale: "en" | "pt-BR"): Record<string, unknown> {
  const characters = d.characters.slice(0, d.characterCount).map((c) => {
    const out: Record<string, unknown> = { type: c.type };
    const name = clean(c.name); if (name) out.name = name;
    for (const k of BLOCK_KEYS) out[k] = block(c[k]);
    return out;
  });
  const intake: Record<string, unknown> = { schema_version: 2, characters, selected_fees: d.manualFees, locale };
  if (d.backgroundType === "complex") {
    const scene: Record<string, unknown> = { refs: d.sceneRefs };
    const description = clean(d.sceneDescription); if (description) scene.description = description;
    intake.scene = scene;
  }
  const notes = clean(d.notes); if (notes) intake.notes = notes;
  return {
    artist_id: artist.id,
    character_count: d.characterCount,
    background_type: d.backgroundType,
    usage_type: d.usageType,
    content_rating: d.contentRating,
    posting_permission: d.postingPermission,
    deadline: d.deadlineMode === "date" ? d.deadline : null,
    client: { name: d.clientName, email: d.clientEmail, discord: d.clientDiscord || undefined },
    studio_tos_hash: artist.studioTosHash,
    artist_tos_hash: artist.artistTosHash,
    intake,
    website: "",
  };
}
